import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import api from '@/api/products';

  @Module({ namespaced: true })
export default class extends VuexModule {
      @Action
  async list(params: any) {
    return api.list(params);
  }

      @Action
      async detail(params: any) {
        return api.detail(params);
      }

      @Action
      async add(params: any) {
        return api.add(params);
      }

      @Action
      async edit(params: any) {
        return api.edit(params);
      }

      @Action
      async delete(params: any) {
        return api.delete(params);
      }

      @Action
      async selectProducts(params: any) {
        return api.selectProducts(params);
      }

      @Action
      async selectCategories(params: any) {
        return api.selectCategories(params);
      }

      @Action
      async categories(params: any) {
        return api.categories(params);
      }

          @Action
      async category(params: any) {
        return api.category(params);
      }

          @Action
          async addCategory(params: any) {
            return api.addCategory(params);
          }

          @Action
          async editCategory(params: any) {
            return api.editCategory(params);
          }

          @Action
          async deleteCategory(params: any) {
            return api.deleteCategory(params);
          }

        @Action
          async setting(params: any) {
            return api.setting(params);
          }

        @Action
        async saveSetting(params: any) {
          return api.saveSetting(params);
        }

        @Action
        async deleteSetting(params: any) {
          return api.deleteSetting(params);
        }
}
